import React from 'react';
import PropTypes from 'prop-types';
import CanvasIntegrationModal from './CanvasIntegrationModal';
import useCredentialStore from './useCredentialStore';

const EditButton = ({
  modalManager,
  subscriberId,
  hasCompletedLTI,
  initialLmsType,
  rootUrl,
}) => {
  const setCanvasCredentials = useCredentialStore(state => state.setCanvasCredentials);
  const setLtiCredentials = useCredentialStore(state => state.setLtiCredentials);

  return (
    <span>
      <button
        type="button"
        className="btn btn--outline-purple btn--sm"
        onClick={modalManager.open}
        aria-label="Edit SSO Setup"
      >
        <i className="fa fa-edit" aria-hidden />
        {' '}
        Edit
      </button>

      <CanvasIntegrationModal
        isEditing
        hasCompletedLTI={hasCompletedLTI}
        initialLmsType={initialLmsType}
        isInitialSetup={false}
        modalManager={modalManager}
        rootUrl={rootUrl}
        setCanvasCredentials={setCanvasCredentials}
        setLtiCredentials={setLtiCredentials}
        subscriberId={subscriberId}
      />
    </span>
  );
};

EditButton.propTypes = {
  hasCompletedLTI: PropTypes.bool.isRequired,
  initialLmsType: PropTypes.string,
  modalManager: PropTypes.shape({
    close: PropTypes.func.isRequired,
    isOpen: PropTypes.bool.isRequired,
    open: PropTypes.func.isRequired
  }).isRequired,
  rootUrl: PropTypes.string.isRequired,
  subscriberId: PropTypes.number.isRequired,
};

EditButton.defaultProps = {
  initialLmsType: null,
};

export default EditButton;
